import { Center, CenterProps, Group, Text } from "@mantine/core"
import { CgSpinner } from "react-icons/cg";

type Props = {
  title?: string
} & CenterProps

export const LoadingSpinner = ({ title = "", ...props }: Props) => {
  return (
    <Center {...props}>
      <Group gap="sm">
        <CgSpinner className="h-8 w-8 animate-spin text-green-500" />
        <Text>{title}</Text>
      </Group>
    </Center>
  )
}
